import {ProductPricing} from "../product-princing.model";
import {Corridor} from "../corridor/corridor";
import {EnumCorridorColor} from "../../enum/enum-corridor-color";
import {InitialArticleInfo} from "./initial-article-info";

export class Article {

    public codeElis?: string;
    public label?: string;
    public productPricings?: ProductPricing[];
    public initialArticleInfo?: InitialArticleInfo;
    public articleDetails?: Record<string, any>;
    public corridor?: Corridor;
    public lastCorridorState?: Corridor;

    public lastAppliedPriceColor?: EnumCorridorColor;
    public discount?: string;
    public status?: string;

    public groupingCode?: string;
    public totalQuantity?: number;
    public isRenewal?: boolean;

    public appliedPrice?: string;
    public distance?: string;
    public appliedPriceColor?: EnumCorridorColor;

    public oldAppliedPrice?: string;
    public oldDistance?: string;
    public oldAppliedPriceColor?: EnumCorridorColor;
    public isCmcWithStandardProductPricing?: boolean;
    public logisticPrice?: string;
    public pcc?: string;
    public pccType?: string;
    public ppe?: boolean;
    public catalogPrice?: string;
    public greenPrice?: string;
    public blackPrice?: string;
    public grossMarginRate?: string;
    public washRate?: string;
    public washLifetime?: string;
    public replacementPrice?: string;

}
